import React from 'react';
import styled from 'styled-components';
// import { Link } from 'gatsby';
// import Logo from './Logo';

const ContentStyles = styled.nav`
  /* margin-bottom: 3rem; */
  position: relative;
`;

export default function Nav({ children }) {
  return <ContentStyles>{children}</ContentStyles>;
}
